import TreeMapFilterItem from "../tree-map-filter-item";
import TreeMapSubFilterCard from "../tree-map-sub-filter-card";

import { useTreeMapFilterAssetState } from "./tree-map-filter-asset-state.hook";

const TreeMapFilterAssetState = () => {
  const { filterItems, onToggle } = useTreeMapFilterAssetState();

  return (
    <TreeMapSubFilterCard type="state">
      {filterItems.map(({ value, name, count, checked, disabled }) => (
        <TreeMapFilterItem
          key={value}
          title={name}
          count={count}
          checked={checked}
          disabled={disabled}
          onToggle={() => onToggle(value, checked)}
        />
      ))}
    </TreeMapSubFilterCard>
  );
};

export default TreeMapFilterAssetState;
